import React from 'react';
import {Link} from "react-router-dom";
import SendIcon from "../assets/send-icon";
import PaperIcon from "../assets/paper-icon";
import UserIcon from "../assets/user-icon";
import SupportIcon from "../assets/support-icon";
import {PATH_APP} from "../routes/paths";

function MainMenu(props) {
    return (
        <div className="main-menu">
            <ul className="list-unstyled d-flex justify-content-around m-0">
                <li>
                    <Link to={PATH_APP.home} className={props.active === "home" ? 'active' : ''}>
                        <UserIcon color="#fff" width="26" height="26"/>
                        پروفایل شما
                    </Link>

                </li>
                <li>
                    <Link to={PATH_APP.practices} className={props.active === "practices" ? 'active' : ''}>
                        <SupportIcon/>
                        نورون درمانی
                    </Link>
                </li>
                <li>
                    <Link to={PATH_APP.diets} className={props.active === "diets" ? 'active' : ''}>
                        <PaperIcon/>
                        برنامه شما
                    </Link>

                </li>

                <li>
                    <Link to={PATH_APP.chat} className={props.active === "support" ? 'active' : ''}>
                        <SendIcon/>
                        پشتیبانی
                    </Link>
                </li>
            </ul>
        </div>
    );
}

export default MainMenu;
